import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

const MOBILE = '@media (max-width: 960px)';

export const Wrap = styled.div`
  width: 100%;
  padding: 9.6rem 7.2rem;
  display: flex;
  flex-direction: column;
  gap: 5.2rem;

  ${MOBILE} {
    padding: 5.6rem 2.4rem;
  }
`;

export const StepGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.4rem;

  ${MOBILE} {
    grid-template-columns: 1fr;
    gap: 1.6rem;
  }
`;

export const StepCard = styled.div`
  position: relative;
  background: ${LandingHero.neutral.cardBg};
  border: 0.1rem solid ${LandingHero.neutral.cardBorder};
  border-radius: 2.2rem;
  padding: 3.4rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  backdrop-filter: blur(1.2rem);
  -webkit-backdrop-filter: blur(1.2rem);
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), border-color 0.4s ease;

  &:hover {
    transform: translateY(-0.6rem);
    border-color: ${LandingHero.pro.cardBorder};
  }

  ${MOBILE} {
    padding: 2.4rem 2.2rem;
  }
`;

export const StepNumber = styled.div<{ $highlight?: boolean }>`
  width: 4.6rem;
  height: 4.6rem;
  border-radius: 1.4rem;
  background: ${({ $highlight }) =>
    $highlight ? LandingHero.ctaGradient : LandingHero.badgeBg};
  border: 0.1rem solid
    ${({ $highlight }) => ($highlight ? 'transparent' : LandingHero.badgeBorder)};
  color: ${({ $highlight }) =>
    $highlight ? LandingHero.ctaText : LandingHero.badgeText};
  font-family: ${HERO_FONT_DISPLAY};
  font-size: 1.9rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StepTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  letter-spacing: -0.02rem;
  color: ${LandingHero.textPrimary};
`;

export const StepDescription = styled.div`
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${LandingHero.textMuted};
`;
